import React, { useState, useContext } from 'react'
import { formatDate, ROUTES } from '../../shared/constants'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useQuery, useQueryClient } from 'react-query'
import { deleteDocumentById, getAllData } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'
import { useChannelType } from '../../hooks/CompanyConfiguration/useChannelType'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'

export default function ChannelTypeMaster() {
  const [searchQuery, setSearchQuery] = useState("")
  const debouncedValue = useDebounce(searchQuery, 500)
  // let { data: channelTypeMaster, isLoading } = useQuery(['channel-type-master', debouncedValue && debouncedValue], () => getAllData('/channel/types', 
  // { searchQuery: debouncedValue }
  // ))
  const [page, setPage] = React.useState(1)
  const {getAllChannelTypeWithParams, pdfCsvData, loading: isLoading, addChannelType} = useChannelType()
  const {channelTypes : channelTypeMaster} = useContext(ConfigurationContext)
  const [multipleDeleteDialog, setMultipleDeleteDialog] = React.useState(false)
  const queryClient = useQueryClient()

  let tmpArr = []
  if (!isLoading && channelTypeMaster?.length > 0) {
    channelTypeMaster.map((item) => {
      return tmpArr.push([{ type: 'CHECKBOX', _id: item._id }, { value: item.name }, { value: formatDate(item.createdAt) }])
    })
  }

  React.useEffect(()=>{
    getAllChannelTypeWithParams({page: page, limit: 15, searchQuery: searchQuery})
  }, [page, searchQuery])

  const layoutProps = {
    heading: 'Manage Channel Type Master',
    url: ROUTES.ADD_CHANNEL_TYPE_MASTER,
    editUrl: 'edit-channel-type-master/',
    setMultipleDeleteDialog: {setMultipleDeleteDialog},
    none : true,
    addnone : true,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    filename: 'channelTypes',
    sampleName: 'sampele_channelTypes',
    sheetName: 'channelTypes',
    tempHeaders: ["name", "createdAt"],
    tempHeaderData : [["Warehouses", "11-07-2022"]],
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    addData: addChannelType,
    setPage: {setPage},
    page: {page},
    permissionName: "MASTERS",

  }
  const handlePageChange = (event, value) => {
    console.log("PAGE", value);
    setPage(value)
  }
  const deleteMany = async (ids) => {
    for await (let id of ids) {
      deleteDocumentById('/delete/channel/type', id)
    }
    queryClient.invalidateQueries('channel-type-master')
  }

  return (
    <CustomTableLayout
      tableHeadings={['Channel Type Name', 'Created At']}
      loading={isLoading}
      tableBody={tmpArr}
      // handleSwitchChange={handleSwitchChange}
      handlePageChange={handlePageChange}
      paginate={{ totalPage: 100, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => {
        deleteMany(val)
        setSelected([])
      }}
    />
  )
}
